import { render } from "./Calendario.vue?vue&type=template&id=b124b41c&scoped=true"
const script = {}

import "./Calendario.vue?vue&type=style&index=0&id=b124b41c&scoped=true&lang=css"

import exportComponent from "/home/lucas/projects/distrisuper/pc-21/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b124b41c"]])

export default __exports__